<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
<div class="dashboard-container">
<app-admin-nav></app-admin-nav>

<div id="dashboard">
    <div class="overview">
        <div class="text-area">
            <span class="title">Overview</span>
            <span class="subtitle">(Last 31 days)</span>
        </div>
        <div class="card-area">
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/euro-icon.png" alt="Revenue">
                    <span>Revenue</span>
                </div>
                <div class="card-value">{{ dashboardStats.totalRevenue || 0 }}€</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">Average order value</div>
                        <div class="value">{{ dashboardStats.avgOrderValue || 0 }}€</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/cart-icon.png" alt="Revenue">
                    <span>Total Orders</span>
                </div>
                <div class="card-value">{{ dashboardStats.totalOrders || 0 }}</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">New</div>
                        <div class="value">{{ statusCount('New') }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">Completed</div>
                        <div class="value">{{ statusCount('Completed') }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">Cancelled</div>
                        <div class="value">{{ statusCount('Cancelled') }}</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/people-icon.png" alt="Revenue">
                    <span>Customers</span>
                </div>
                <div class="card-value">{{ dashboardStats.customers?.total || 0 }}</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">New</div>
                        <div class="value">{{ dashboardStats.customers?.new || 0 }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">Returning</div>
                        <div class="value">{{ dashboardStats.customers?.returning || 0 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="orders">
        <span class="header">Latest orders</span>
        <!-- Scrolls horizontally on narrow screens; the page itself clips
             overflow (html/body use overflow-x: hidden). -->
        <div class="table-scroll">
        <table mat-table [dataSource]="orders" class="custom-table">

            <!-- Order ID -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Order No. </th>
                <td mat-cell *matCellDef="let order"> #{{ order.orderNo }} </td>
            </ng-container>

            <!-- Client Name -->
            <ng-container matColumnDef="clientName">
                <th mat-header-cell *matHeaderCellDef> Client email </th>
                <td mat-cell *matCellDef="let order"> {{ order.contactDetails.email }} </td>
            </ng-container>

            <!-- Date -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let order"> {{ order.createdAt | customDate }} </td>
            </ng-container>

            <!-- Amount -->
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef> Amount </th>
                <td mat-cell *matCellDef="let order"> €{{ order.totalPrice }} </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let order">
                    <span class="status" [ngClass]="order.status?.toLowerCase()">
                        <span class="dot"></span> {{ order.status }}
                    </span>
                </td>
            </ng-container>

            <!-- Assigned -->
            <ng-container matColumnDef="assignedTo">
                <th mat-header-cell *matHeaderCellDef> Assigned To </th>
                <td mat-cell *matCellDef="let order"> {{ order.assignedTo ? order.assignedTo : '-' }} </td>
            </ng-container>

            <!-- Menu -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let order">
                    <i class="fa-solid fa-eye cursor-pointer" style="color: #96A6B7;" (click)="viewOrder(order)"></i>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        </div>
    </div>

</div>
</div>
</div>

<app-footer></app-footer>